export default function LegalDocumentChecklist() {
  const documents = [
    {
      category: 'Probate Documents',
      items: [
        { name: 'Death Certificate', description: 'Certified copies (usually need 5-10)', required: true },
        { name: 'Will or Trust Documents', description: 'Original or certified copy', required: true },
        { name: 'Letters Testamentary', description: 'Court document appointing executor', required: true },
        { name: 'Probate Court Order', description: 'Authorization to sell real estate', required: true }
      ]
    },
    {
      category: 'Property Documents',
      items: [
        { name: 'Property Deed', description: 'Showing current ownership', required: true },
        { name: 'Title Insurance Policy', description: 'From original purchase', required: false },
        { name: 'Property Tax Records', description: 'Last 2-3 years', required: true },
        { name: 'Mortgage Documents', description: 'If property has existing loan', required: true }
      ]
    },
    {
      category: 'Financial Records',
      items: [
        { name: 'Rent Roll', description: 'Current tenant list with rents', required: true },
        { name: 'Lease Agreements', description: 'All current tenant leases', required: true },
        { name: 'Operating Expenses', description: 'Last 12-24 months', required: false },
        { name: 'Property Tax Bills', description: 'Most recent statements', required: true }
      ]
    },
    {
      category: 'Additional Items',
      items: [
        { name: 'Property Insurance', description: 'Current policy information', required: true },
        { name: 'Utility Account Info', description: 'For transfer at closing', required: false },
        { name: 'HOA Documents', description: 'If applicable', required: false },
        { name: 'Property Inspection Reports', description: 'If available', required: false }
      ]
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Document Checklist for Selling Inherited Property
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Gathering these documents early streamlines the sale process. Don't worry if you're missing some—we'll help you obtain what's needed.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {documents.map((category, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold mb-6 text-gray-900 flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-teal-500 text-white rounded-lg">
                  <i className="ri-file-list-3-line text-xl"></i>
                </div>
                {category.category}
              </h3>
              <div className="space-y-4">
                {category.items.map((item, idx) => (
                  <div key={idx} className="flex items-start gap-4 pb-4 border-b border-gray-200 last:border-b-0 last:pb-0">
                    <div className="flex-shrink-0 mt-1">
                      {item.required ? (
                        <i className="ri-checkbox-circle-fill text-teal-500 text-xl"></i>
                      ) : (
                        <i className="ri-checkbox-blank-circle-line text-gray-400 text-xl"></i>
                      )}
                    </div>
                    <div className="flex-grow">
                      <div className="flex items-center gap-2 mb-1">
                        <h4 className="font-bold text-gray-900">{item.name}</h4>
                        {item.required && (
                          <span className="bg-red-100 text-red-700 px-2 py-1 rounded text-xs font-semibold">
                            Required
                          </span>
                        )}
                      </div>
                      <p className="text-sm text-gray-600">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-10">
          <div className="flex items-start gap-6">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-500 text-white rounded-full flex-shrink-0">
              <i className="ri-hand-heart-line text-3xl"></i>
            </div>
            <div>
              <h3 className="text-3xl font-bold mb-4 text-gray-900">We Make It Easy</h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                Don't let missing documents stress you out. We've worked with hundreds of inherited properties and know how to navigate incomplete records, lost paperwork, and complex situations.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-1"></i>
                  <span className="text-gray-700"><strong className="text-gray-900">We'll help you obtain missing documents</strong> through public records and title searches</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-1"></i>
                  <span className="text-gray-700"><strong className="text-gray-900">We work with your probate attorney</strong> to ensure all legal requirements are met</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-1"></i>
                  <span className="text-gray-700"><strong className="text-gray-900">We can proceed with limited information</strong> and fill in gaps during due diligence</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
